import { CollectActionBragg } from "@spawn/backend-adapter-bragg";
import { DiProjectBuilder, IExtendableDiProject } from "@spawn/core";
import { CoreAssetsDiProject } from "@spawn/core-assets";
import { FreegameActions, FreegamesDiProject } from "@spawn/freegames";
import { GoldenBonusDiProject } from "@spawn/golden-bonus";
import { ModernUiDiProject } from "@spawn/modern-ui";
import { AdapterActions, Jurisdiction } from "@spawn/networking";
import { NudgingDiProject } from "@spawn/nudge";
import { RevealDiProject } from "@spawn/reveal";
import {
	FastPaceCZ,
	FastPaceDE,
	FastPaceES,
	FastPaceSE,
	FastPaceShort,
	FastPaceUK,
	SlotMachineDiProject,
} from "@spawn/slot-machine";
import { ExtendedBetChangeActionBragg } from "./network/bragg/extendedBetChangeActionBragg";
import { ExtendedInitActionBragg } from "./network/bragg/extendedInitActionBragg";
import { ExtendedSpinActionBragg } from "./network/bragg/extendedSpinActionBragg";
import { FGInitActionBragg } from "./network/bragg/fgInitActionBragg";
import { FGPseudoInitActionBragg } from "./network/bragg/fgPseudoInitActionBragg";
import { FGPseudoSpinActionBragg } from "./network/bragg/fgPseudoSpinActionBragg";
import { FGSpinActionBragg } from "./network/bragg/fgSpinActionBragg";
import { ExtendedBetChangeActionCube } from "./network/cube/extendedBetChangeActionCube";
import { ExtendedInitActionCube } from "./network/cube/extendedInitActionCube";
import { ExtendedSpinActionCube } from "./network/cube/extendedSpinActionCube";
import { FGInitActionCube } from "./network/cube/fgInitActionCube";
import { FGPseudoInitActionCube } from "./network/cube/fgPseudoInitActionCube";
import { FGPseudoSpinActionCube } from "./network/cube/fgPseudoSpinActionCube";
import { FGSpinActionCube } from "./network/cube/fgSpinActionCube";
import { NrgGameDiProject } from "./nrgGameDiProject";

/** Creates the DI project builder of a game: the backend actions, the spin configs and the feature projects. */
export function createProjectBuilder(gameDiProject: IExtendableDiProject<NrgGameDiProject>): DiProjectBuilder<NrgGameDiProject> {
	return DiProjectBuilder.create(gameDiProject)
		.configureProject(SlotMachineDiProject, {
			adapterActions: {
				cube: {
					[AdapterActions.Init]: ExtendedInitActionCube,
					[AdapterActions.Spin]: ExtendedSpinActionCube,
					[AdapterActions.ChangeBet]: ExtendedBetChangeActionCube,
					[FreegameActions.FreegameSpin]: FGSpinActionCube,
					[FreegameActions.FreegameInit]: FGInitActionCube,
					["PSEUDO_SPIN"]: FGPseudoSpinActionCube,
					["PSEUDO_INIT"]: FGPseudoInitActionCube,
				},
				bragg: {
					...FreegamesDiProject.adapterActions.bragg,
					[AdapterActions.Init]: ExtendedInitActionBragg,
					[AdapterActions.Spin]: ExtendedSpinActionBragg,
					[AdapterActions.ChangeBet]: ExtendedBetChangeActionBragg,
					[AdapterActions.Collect]: CollectActionBragg, // use the basegame action instead of the extended one as that wrongly increases the current round number when exiting freegames
					[FreegameActions.FreegameSpin]: FGSpinActionBragg,
					[FreegameActions.FreegameInit]: FGInitActionBragg,
					["PSEUDO_SPIN"]: FGPseudoSpinActionBragg,
					["PSEUDO_INIT"]: FGPseudoInitActionBragg,
				},
			},
			spinConfigs: {
				[Jurisdiction.None]: FastPaceShort,
				[Jurisdiction.De]: FastPaceDE,
				[Jurisdiction.Uk]: FastPaceUK,
				[Jurisdiction.Se]: FastPaceSE,
				[Jurisdiction.Cz]: FastPaceCZ,
				[Jurisdiction.Es]: FastPaceES,
			},
		})
		.configureProject(ModernUiDiProject)
		.configureProject(FreegamesDiProject)
		.configureProject(RevealDiProject)
		.configureProject(NudgingDiProject)
		.configureProject(GoldenBonusDiProject)
		.configureProject(gameDiProject)
		.configureProject(CoreAssetsDiProject);
}
